/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BookBean', 'model/BookRequest', 'model/BookResponse', 'model/BuildingBean', 'model/BuildingRequest', 'model/BuildingResponse', 'model/BusinessBean', 'model/BusinessRequest', 'model/BusinessResponse', 'model/CalendarBean', 'model/CalendarRequest', 'model/CalendarResponse', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/GenericBean', 'model/LoginRequest', 'model/LoginResponse', 'model/MigrateRequest', 'model/MigrateResponse', 'model/NotificationBean', 'model/NotificationRequest', 'model/NotificationResponse', 'model/PaymentBean', 'model/PaymentRequest', 'model/PaymentResponse', 'model/RoomBean', 'model/RoomRequest', 'model/RoomResponse', 'model/RuleBean', 'model/RuleRequest', 'model/RuleResponse', 'model/ScheduleBean', 'model/ScheduleRequest', 'model/ScheduleResponse', 'model/ServiceBean', 'model/ServiceRequest', 'model/ServiceResponse', 'model/SetBean', 'model/SetRequest', 'model/SetResponse', 'model/SwapBean', 'model/SwapRequest', 'model/SwapResponse', 'model/UserBean', 'model/UserRequest', 'model/UserResponse', 'model/VoucherBean', 'model/VoucherRequest', 'model/VoucherResponse', 'api/DefaultApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/BookBean'), require('./model/BookRequest'), require('./model/BookResponse'), require('./model/BuildingBean'), require('./model/BuildingRequest'), require('./model/BuildingResponse'), require('./model/BusinessBean'), require('./model/BusinessRequest'), require('./model/BusinessResponse'), require('./model/CalendarBean'), require('./model/CalendarRequest'), require('./model/CalendarResponse'), require('./model/ConfigurationRequest'), require('./model/ConfigurationResponse'), require('./model/GenericBean'), require('./model/LoginRequest'), require('./model/LoginResponse'), require('./model/MigrateRequest'), require('./model/MigrateResponse'), require('./model/NotificationBean'), require('./model/NotificationRequest'), require('./model/NotificationResponse'), require('./model/PaymentBean'), require('./model/PaymentRequest'), require('./model/PaymentResponse'), require('./model/RoomBean'), require('./model/RoomRequest'), require('./model/RoomResponse'), require('./model/RuleBean'), require('./model/RuleRequest'), require('./model/RuleResponse'), require('./model/ScheduleBean'), require('./model/ScheduleRequest'), require('./model/ScheduleResponse'), require('./model/ServiceBean'), require('./model/ServiceRequest'), require('./model/ServiceResponse'), require('./model/SetBean'), require('./model/SetRequest'), require('./model/SetResponse'), require('./model/SwapBean'), require('./model/SwapRequest'), require('./model/SwapResponse'), require('./model/UserBean'), require('./model/UserRequest'), require('./model/UserResponse'), require('./model/VoucherBean'), require('./model/VoucherRequest'), require('./model/VoucherResponse'), require('./api/DefaultApi'));
  }
}(function(ApiClient, BookBean, BookRequest, BookResponse, BuildingBean, BuildingRequest, BuildingResponse, BusinessBean, BusinessRequest, BusinessResponse, CalendarBean, CalendarRequest, CalendarResponse, ConfigurationRequest, ConfigurationResponse, GenericBean, LoginRequest, LoginResponse, MigrateRequest, MigrateResponse, NotificationBean, NotificationRequest, NotificationResponse, PaymentBean, PaymentRequest, PaymentResponse, RoomBean, RoomRequest, RoomResponse, RuleBean, RuleRequest, RuleResponse, ScheduleBean, ScheduleRequest, ScheduleResponse, ServiceBean, ServiceRequest, ServiceResponse, SetBean, SetRequest, SetResponse, SwapBean, SwapRequest, SwapResponse, UserBean, UserRequest, UserResponse, VoucherBean, VoucherRequest, VoucherResponse, DefaultApi) {
  'use strict';

  /**
   * ERROR_UNKNOWN.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var BelfastpilatesProductionappspotcom = require('index'); // See note below*.
   * var xxxSvc = new BelfastpilatesProductionappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new BelfastpilatesProductionappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new BelfastpilatesProductionappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new BelfastpilatesProductionappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The BookBean model constructor.
     * @property {module:model/BookBean}
     */
    BookBean: BookBean,
    /**
     * The BookRequest model constructor.
     * @property {module:model/BookRequest}
     */
    BookRequest: BookRequest,
    /**
     * The BookResponse model constructor.
     * @property {module:model/BookResponse}
     */
    BookResponse: BookResponse,
    /**
     * The BuildingBean model constructor.
     * @property {module:model/BuildingBean}
     */
    BuildingBean: BuildingBean,
    /**
     * The BuildingRequest model constructor.
     * @property {module:model/BuildingRequest}
     */
    BuildingRequest: BuildingRequest,
    /**
     * The BuildingResponse model constructor.
     * @property {module:model/BuildingResponse}
     */
    BuildingResponse: BuildingResponse,
    /**
     * The BusinessBean model constructor.
     * @property {module:model/BusinessBean}
     */
    BusinessBean: BusinessBean,
    /**
     * The BusinessRequest model constructor.
     * @property {module:model/BusinessRequest}
     */
    BusinessRequest: BusinessRequest,
    /**
     * The BusinessResponse model constructor.
     * @property {module:model/BusinessResponse}
     */
    BusinessResponse: BusinessResponse,
    /**
     * The CalendarBean model constructor.
     * @property {module:model/CalendarBean}
     */
    CalendarBean: CalendarBean,
    /**
     * The CalendarRequest model constructor.
     * @property {module:model/CalendarRequest}
     */
    CalendarRequest: CalendarRequest,
    /**
     * The CalendarResponse model constructor.
     * @property {module:model/CalendarResponse}
     */
    CalendarResponse: CalendarResponse,
    /**
     * The ConfigurationRequest model constructor.
     * @property {module:model/ConfigurationRequest}
     */
    ConfigurationRequest: ConfigurationRequest,
    /**
     * The ConfigurationResponse model constructor.
     * @property {module:model/ConfigurationResponse}
     */
    ConfigurationResponse: ConfigurationResponse,
    /**
     * The GenericBean model constructor.
     * @property {module:model/GenericBean}
     */
    GenericBean: GenericBean,
    /**
     * The LoginRequest model constructor.
     * @property {module:model/LoginRequest}
     */
    LoginRequest: LoginRequest,
    /**
     * The LoginResponse model constructor.
     * @property {module:model/LoginResponse}
     */
    LoginResponse: LoginResponse,
    /**
     * The MigrateRequest model constructor.
     * @property {module:model/MigrateRequest}
     */
    MigrateRequest: MigrateRequest,
    /**
     * The MigrateResponse model constructor.
     * @property {module:model/MigrateResponse}
     */
    MigrateResponse: MigrateResponse,
    /**
     * The NotificationBean model constructor.
     * @property {module:model/NotificationBean}
     */
    NotificationBean: NotificationBean,
    /**
     * The NotificationRequest model constructor.
     * @property {module:model/NotificationRequest}
     */
    NotificationRequest: NotificationRequest,
    /**
     * The NotificationResponse model constructor.
     * @property {module:model/NotificationResponse}
     */
    NotificationResponse: NotificationResponse,
    /**
     * The PaymentBean model constructor.
     * @property {module:model/PaymentBean}
     */
    PaymentBean: PaymentBean,
    /**
     * The PaymentRequest model constructor.
     * @property {module:model/PaymentRequest}
     */
    PaymentRequest: PaymentRequest,
    /**
     * The PaymentResponse model constructor.
     * @property {module:model/PaymentResponse}
     */
    PaymentResponse: PaymentResponse,
    /**
     * The RoomBean model constructor.
     * @property {module:model/RoomBean}
     */
    RoomBean: RoomBean,
    /**
     * The RoomRequest model constructor.
     * @property {module:model/RoomRequest}
     */
    RoomRequest: RoomRequest,
    /**
     * The RoomResponse model constructor.
     * @property {module:model/RoomResponse}
     */
    RoomResponse: RoomResponse,
    /**
     * The RuleBean model constructor.
     * @property {module:model/RuleBean}
     */
    RuleBean: RuleBean,
    /**
     * The RuleRequest model constructor.
     * @property {module:model/RuleRequest}
     */
    RuleRequest: RuleRequest,
    /**
     * The RuleResponse model constructor.
     * @property {module:model/RuleResponse}
     */
    RuleResponse: RuleResponse,
    /**
     * The ScheduleBean model constructor.
     * @property {module:model/ScheduleBean}
     */
    ScheduleBean: ScheduleBean,
    /**
     * The ScheduleRequest model constructor.
     * @property {module:model/ScheduleRequest}
     */
    ScheduleRequest: ScheduleRequest,
    /**
     * The ScheduleResponse model constructor.
     * @property {module:model/ScheduleResponse}
     */
    ScheduleResponse: ScheduleResponse,
    /**
     * The ServiceBean model constructor.
     * @property {module:model/ServiceBean}
     */
    ServiceBean: ServiceBean,
    /**
     * The ServiceRequest model constructor.
     * @property {module:model/ServiceRequest}
     */
    ServiceRequest: ServiceRequest,
    /**
     * The ServiceResponse model constructor.
     * @property {module:model/ServiceResponse}
     */
    ServiceResponse: ServiceResponse,
    /**
     * The SetBean model constructor.
     * @property {module:model/SetBean}
     */
    SetBean: SetBean,
    /**
     * The SetRequest model constructor.
     * @property {module:model/SetRequest}
     */
    SetRequest: SetRequest,
    /**
     * The SetResponse model constructor.
     * @property {module:model/SetResponse}
     */
    SetResponse: SetResponse,
    /**
     * The SwapBean model constructor.
     * @property {module:model/SwapBean}
     */
    SwapBean: SwapBean,
    /**
     * The SwapRequest model constructor.
     * @property {module:model/SwapRequest}
     */
    SwapRequest: SwapRequest,
    /**
     * The SwapResponse model constructor.
     * @property {module:model/SwapResponse}
     */
    SwapResponse: SwapResponse,
    /**
     * The UserBean model constructor.
     * @property {module:model/UserBean}
     */
    UserBean: UserBean,
    /**
     * The UserRequest model constructor.
     * @property {module:model/UserRequest}
     */
    UserRequest: UserRequest,
    /**
     * The UserResponse model constructor.
     * @property {module:model/UserResponse}
     */
    UserResponse: UserResponse,
    /**
     * The VoucherBean model constructor.
     * @property {module:model/VoucherBean}
     */
    VoucherBean: VoucherBean,
    /**
     * The VoucherRequest model constructor.
     * @property {module:model/VoucherRequest}
     */
    VoucherRequest: VoucherRequest,
    /**
     * The VoucherResponse model constructor.
     * @property {module:model/VoucherResponse}
     */
    VoucherResponse: VoucherResponse,
    /**
     * The DefaultApi service constructor.
     * @property {module:api/DefaultApi}
     */
    DefaultApi: DefaultApi
  };

  return exports;
}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/index.js